import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { sendServiceQuotation } from "../../../../services/ReportService";
import Select from "react-select";
import { findByLicensePlate } from "../../../../services/CarService";
import currencyBRFormat from "../../../../util/CurrencyUtils";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import ReactInputMask from "react-input-mask";
import removerSpecialChars from "../../../../util/StringUtils";
import { findCustomerByPhone } from "../../../../services/CustomerService";
import Spinner from "../../../../components/Spinner";
import carBrands from "../../../../consts/CarBrands";
import CadastrarServicoModal from "./CadastrarServicoModal";

export const OrcamentoModal = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [searchingCar, setSearchingCar] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  // TRANSFORMAÇÃO DE REFS EM ESTADOS REATIVOS (PADRÃO REACT 18)
  const [licensePlate, setLicensePlate] = useState("");
  const [vehicleColor, setVehicleColor] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [comments, setComments] = useState("");
  const [address, setAddress] = useState("");

  // ESTADOS PARA CONTROLE DE INPUTS DESABILITADOS
  const [customerNameDisabled, setCustomerNameDisabled] = useState(false);
  const [addressDisabled, setAddressDisabled] = useState(false);
  const [vehicleColorDisabled, setVehicleColorDisabled] = useState(false);
  const [vehicleModelDisabled, setVehicleModelDisabled] = useState(false);

  const [vehicleBrand, setVehicleBrand] = useState();
  const [brandSelectDisabled, setBrandSelectDisabled] = useState(false);
  const [modalServicoOpen, setModalServicoOpen] = useState(false);

  // ESTADOS CONVERTIDOS PARA O FLUXO DE ITENS/PEÇAS
  const [itemName, setItemName] = useState("");
  const [itemValue, setItemValue] = useState("");
  const [itemQtd, setItemQtd] = useState(1);
  const [selectedServies, setSelectedServies] = useState([]);

  // ÚNICO REF PERMITIDO: Para dar foco automático sem quebrar eventos
  const licensePlateRef = useRef(null);

  useEffect(() => {}, [isOpen]);

  function findByPhone() {
    findCustomerByPhone("55" + removerSpecialChars(customerPhone))
      .then((response) => {
        if (response) {
          fillInputsCustomer(response);
        } else {
          clearInputsCustomer();
        }
      })
      .catch((error) => {
        clearInputsCustomer();
      });
  }

  function fillInputsCustomer(response) {
    setCustomerName(response.name);
    setAddress(response.address || "");
    setCustomerNameDisabled(true);
    setAddressDisabled(true);
  }

  function clearInputsCustomer() {
    setCustomerNameDisabled(false);
    setAddressDisabled(false);
    setCustomerName("");
    setAddress("");
  }

  function fillInputsVehicle(response, currentPlate) {
    setSearchingCar(false);
    setVehicleBrand({
      key: response.brand,
      label: response.brand.replace("_", " "),
      value: response.brand.replace("_", " "),
    });

    setLicensePlate(currentPlate);
    setVehicleColor(response.color);
    setVehicleModel(response.model);

    setBrandSelectDisabled(true);
    setVehicleColorDisabled(true);
    setVehicleModelDisabled(true);
  }

  function clearInputsVehicle() {
    setSearchingCar(false);
    setVehicleColorDisabled(false);
    setVehicleModelDisabled(false);

    setVehicleBrand(null);
    setBrandSelectDisabled(false);
  }

  function addItem() {
    if (itemName && itemValue) {
      const item = {
        value: itemName,
        label: itemName,
        key: itemValue,
      };
      setSelectedServies((prevLista) => [...prevLista, item]);
      setItemName("");
      setItemValue("");
      setItemQtd(1);
    } else {
      toast.warning("Nome e valor dos Serviços/Peças devem ser informados");
    }
  }

  function handleInputLicensePlate(e) {
    setLicensePlate(e.target.value.toUpperCase());
  }

  // EFEITO COLATERAIS REATIVOS PARA A BUSCA DA PLACA
  useEffect(() => {
    if (licensePlate && licensePlate.length === 7) {
      setSearchingCar(true);
      findByLicensePlate(licensePlate)
        .then((response) => {
          if (response) {
            fillInputsVehicle(response, licensePlate);
          } else {
            clearInputsVehicle();
          }
        })
        .catch((error) => {
          setSearchingCar(false);
          setVehicleBrand(null);
          setBrandSelectDisabled(false);
        });
    } else {
      setVehicleColor("");
      setVehicleModel("");
      clearInputsVehicle();
    }
  }, [licensePlate]);

  const formatServicesLabels = (service) => (
    <>
      <span>{service.label}</span>
      <span> - R$ {service.key}</span>
    </>
  );

  function handleSubmit(e) {
    setWaiting(true);
    e.preventDefault();

    const data = {
      vehicle: {
        licensePlate: licensePlate,
        brand: vehicleBrand ? vehicleBrand.key : "",
        color: vehicleColor,
        model: vehicleModel,
      },
      employeeName: localStorage.getItem("userName"),
      servicesAndParts: selectedServices.map((service) => ({
        id: service.value,
        name: service.label,
        value: parseFloat(service.key),
      })),
      customer: {
        name: customerName,
        phone: "55" + removerSpecialChars(customerPhone),
        address: address,
        notify: true,
      },
      comments: comments,
    };

    sendServiceQuotation(data)
      .then((response) => {
        toast.success(response);
        setWaiting(false);
      })
      .catch((error) => {
        console.log(error);
        if (error && error.response) toast.error(error.response.data);
        else
          toast.error(
            "Não foi possivel enviar orçamento, verifique o telefone do cliente e tente novamente",
          );
        setWaiting(false);
      });
  }

  function calculateTotalSelectServices() {
    return currencyBRFormat(
      selectedServices
        .map((service) => service.key)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
    );
  }

  return (
    <div>
      <CadastrarServicoModal
        setModalServicoOpen={setModalServicoOpen}
        modalServicoOpen={modalServicoOpen}
        listServices={props.listServices}
      />
      <button className="btn" type="button" onClick={() => setIsOpen(true)}>
         <i className="fa fa-calculator me-2"></i>Orçamento
      </button>

      <Modal
        isOpen={isOpen}
        backdrop="static"
        size="lg"
        centered
        contentClassName="border-0 rounded-4 shadow-lg"
        onOpened={() => licensePlateRef.current?.focus()} // Executa o foco perfeitamente pós-animação
      >
        <ModalHeader className="no-select border-bottom-0 pb-0 pt-4 px-4" toggle={toggle}>
          <span className="fw-bold text-primary">Novo Orçamento</span>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="p-4">
            
            {/* SEÇÃO 1: DADOS DO CLIENTE */}
            <div className="bg-white p-3 rounded-4 border shadow-sm mb-4">
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-user me-2"></i>
                <span className="fw-bold text-muted small text-uppercase">Dados do Cliente</span>
              </div>
              <div className="row g-3">
                <div className="col-lg-6">
                  <label className="form-label small fw-bold text-dark">Telefone <span className="text-danger">*</span></label>
                  <ReactInputMask
                    autoComplete="off"
                    className="form-control form-control-lg fs-6 rounded-3 border-2 fw-bold text-primary"
                    mask="(99) 99999-9999"
                    inputMode="numeric"
                    value={customerPhone}
                    onChange={(e) => setCustomerPhone(e.target.value)}
                    onBlur={findByPhone}
                    required
                    placeholder="(00) 00000-0000"
                  />
                </div>
                <div className="col-lg-6">
                  <label className="form-label small fw-bold text-dark">Nome <span className="text-danger">*</span></label>
                  <input
                    autoComplete="off"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    disabled={customerNameDisabled}
                    required
                    placeholder="Nome do cliente"
                  />
                </div>
                <div className="col-lg-12">
                  <label className="form-label small fw-bold text-dark">Endereço <span className="text-muted fw-normal">(opcional)</span></label>
                  <input
                    autoComplete="off"
                    className="form-control rounded-3 border-2"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    disabled={addressDisabled}
                    placeholder="Rua, número, bairro..."
                  />
                </div>
              </div>
            </div>

            {/* SEÇÃO 2: DADOS DO VEÍCULO */}
            <div className="bg-light p-3 rounded-4 border mb-4">
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-car me-2"></i>
                <span className="fw-bold text-muted small text-uppercase">Dados do Veículo</span>
              </div>

              {searchingCar ? (
                <div className="text-center py-3"><Spinner color="primary" /></div>
              ) : (
                <div className="row g-3">
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Placa <span className="text-danger">*</span></label>
                    <input
                      ref={licensePlateRef}
                      onChange={handleInputLicensePlate}
                      value={licensePlate}
                      type="text"
                      id="placaCarro"
                      maxLength={7}
                      minLength={7}
                      className="form-control form-control-lg fw-bold text-uppercase border-2 bg-white"
                      style={{ letterSpacing: '2px' }}
                      required
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Marca <span className="text-danger">*</span></label>
                    <Select
                      id="selectBrand"
                      name="brands"
                      classNamePrefix="select"
                      onChange={(brand) => setVehicleBrand(brand)}
                      value={vehicleBrand}
                      options={carBrands.map((brand) => ({
                        value: brand.replace("_", " "),
                        key: brand,
                        label: brand.replace("_", " "),
                      }))}
                      placeholder="Marca..."
                      isDisabled={brandSelectDisabled}
                      required
                      styles={{ control: (b) => ({ ...b, borderRadius: '8px', minHeight: '48px' }) }}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Modelo <span className="text-danger">*</span></label>
                    <input
                      id="modeloCarro"
                      className="form-control form-control-lg fs-6"
                      value={vehicleModel}
                      onChange={(e) => setVehicleModel(e.target.value)}
                      disabled={vehicleModelDisabled}
                      placeholder="Ex: Onix"
                      required
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="form-label small fw-bold text-dark">Cor</label>
                    <input
                      id="corCarro"
                      className="form-control form-control-lg fs-6"
                      value={vehicleColor}
                      onChange={(e) => setVehicleColor(e.target.value)}
                      disabled={vehicleColorDisabled}
                      placeholder="Ex: Branco"
                    />
                  </div>
                </div>
              )}
            </div>

            {/* SEÇÃO 3: SERVIÇOS E OBSERVAÇÕES */}
            <div className="bg-light p-3 rounded-4 border">
              <div className="row g-4">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-bold text-muted small text-uppercase mb-0">Serviços</label>
                    <button
                      onClick={() => setModalServicoOpen(true)}
                      type="button"
                      className="btn btn-sm btn-primary rounded-pill px-3 fw-bold"
                      style={{ fontSize: "0.75rem" }}
                    >
                      <i className="fas fa-plus me-1"></i> Novo Serviço
                    </button>
                  </div>
                  <Select
                    onChange={(data) => setSelectedServices(data)}
                    id="listaServicos"
                    isMulti
                    name="services"
                    classNamePrefix="select"
                    options={props.services}
                    value={selectedServices}
                    formatOptionLabel={formatServicesLabels}
                    placeholder="Selecione os serviços..."
                    isClearable
                    required
                    styles={{ control: (b) => ({ ...b, borderRadius: '8px' }) }}
                  />
                  <div className="text-end mt-2">
                    <span className="text-muted small fw-bold text-uppercase me-2">Total Estimado:</span>
                    <span className="h5 fw-bold text-primary mb-0">{calculateTotalSelectServices()}</span>
                  </div>
                </div>

                <div className="col-lg-12">
                  <label className="form-label fw-bold text-muted small text-uppercase mb-2">Observações Internas / Termos</label>
                  <textarea
                    className="form-control rounded-3 border-2"
                    rows="2"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Ex: Os valores podem sofrer alteração após lavagem técnica e detalhamento."
                  />
                </div>
              </div>
            </div>
          </ModalBody>

          {/* FOOTER PADRÃO ALCON AUTO */}
          <ModalFooter className="border-top-0 p-4 pt-0">
            {!waiting ? (
              <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end">
                <button 
                  type="submit" 
                  className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm order-0 px-sm-5"
                  style={{ minWidth: '200px' }}
                >
                  <i className="fas fa-file-signature me-2"></i> Criar Orçamento
                </button>
                
                <button 
                  type="button" 
                  onClick={() => setIsOpen(false)} 
                  className="btn btn-outline-danger btn-lg rounded-3 border-2 order-1"
                >
                  Cancelar
                </button>
              </div>
            ) : (
              <div className="w-100 text-center py-2">
                <div className="spinner-border text-primary" role="status"></div>
              </div>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default OrcamentoModal;